// @deprecated (heroImageCarousel) — slider config moved to:
//   assets/js/components/ui-components/slick-slider.js (preset "booking-solution-hero")
//   Template updated: templates/public/static/booking-solution/main-content.html.twig (data-lazy-init on .bs__carousel)
import $ from "jquery";
import {getMode} from "../media";

//console.log('booking solution')

if($(".widget_btn")){
    $(".widget_btn").click(function(){
        $("#sb_enterprise_widget").trigger("click");
    });
}

// if($('.faq-section .masonry-grid--item-toggler')){
//     $('.faq-section .masonry-grid--item-toggler').on('click', function (){
//         $(this).toggleClass('--active');
//         $(this).closest('.masonry-grid--item').find('.masonry-grid--item-body').slideToggle();
//     })
// }

